// Rote Fehlerleiste oben im Formular (Handoff §5): Text unverändert aus dem Code, per aria-live angesagt.
import { useEffect, useRef } from 'react';
import { WarningCircle, X } from '@phosphor-icons/react';
import { FEHLER } from './form-stil';

export function FormFehler({ text, onSchliessen }: { text: string | null; onSchliessen?: () => void }) {
  const ref = useRef<HTMLDivElement>(null);
  // Neuer Fehler → Leiste in den sichtbaren Bereich holen (sie steht oben, gespeichert wird unten).
  useEffect(() => {
    if (text) ref.current?.scrollIntoView?.({ block: 'nearest', behavior: 'smooth' });
  }, [text]);
  return (
    // Die Live-Region bleibt immer im DOM, damit Screenreader neue Texte zuverlässig ansagen.
    <div ref={ref} role="alert" aria-live="assertive" aria-atomic="true">
      {text && (
        <div key={text} className="pf-shake flex items-start" style={{
          gap: 10, padding: '12px 14px', borderRadius: 16, background: FEHLER.flaeche, boxShadow: FEHLER.ring,
        }}>
          <WarningCircle aria-hidden size={18} weight="fill" color={FEHLER.icon} className="shrink-0" style={{ marginTop: 1 }} />
          <span className="min-w-0 flex-1" style={{ fontSize: 13, fontWeight: 600, lineHeight: 1.4, color: FEHLER.text }}>{text}</span>
          {onSchliessen && (
            <button type="button" onClick={onSchliessen} aria-label="Meldung schließen" className="flex shrink-0 cursor-pointer items-center justify-center rounded-full border-none"
              style={{ width: 22, height: 22, background: 'rgba(255,255,255,0.08)', color: FEHLER.text }}>
              <X size={10} weight="bold" />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
